import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { IStepOption, TourService } from 'ngx-ui-tour-md-menu';
import { map, Observable, shareReplay } from 'rxjs';
import { updateUserUIFunctionalityStatus } from 'src/app/graphql/mutations.graphql';
import { getUserFeatureStatus, getUserUIFunctionalityStatus } from 'src/app/graphql/queries.graphql';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UiTourApiService {
  tourStatus$: Observable<any> | null = null;
  activeTourData: IStepOption[] = [];
  eventData = [];

  constructor(
    private tourService: TourService,
    private apollo: Apollo,
  ) { }

  showTour(tourData: IStepOption[], tourName: string): void {
    if (environment.uiTourEnabled) {
      this.activeTourData = tourData;
      this.getTourStatus().subscribe((response) => {
        this.showTourAsPerStatus(tourData, response[tourName]);
      });
    }
  }
  
  showTourAsPerStatus(tourData: any, tourStatus: any): void {
    let finalTourData = [];
    for (const tour of tourData) {
      let tourID = tour.tourId;
      if (tour.tourId.includes('-') && tour.tourId.includes('NA')) {
        tourID = tour.tourId.split('-')[0];
      }
      if (tourStatus[tourID] === '1') {
        finalTourData.push(tour);
      }
    }
    this.tourService.initialize(finalTourData, {
      enableBackdrop: true,
    });
    this.tourService.start();
  }

  deregisterTour(): void {
    this.tourService.end();
  }

  getTourStatus(): any {
    // API call to get tour status
    if (!this.tourStatus$) {
      this.tourStatus$ = this.apollo.watchQuery<any>({
        query: getUserFeatureStatus,
      }).valueChanges.pipe(map(result => result.data?.getUserFeatureStatus),
        shareReplay(1)
      );
    }
    return this.tourStatus$;
  }

  getTourStepStatus(functionalityCode: string): any {
    return this.apollo.watchQuery<any>({
      query: getUserUIFunctionalityStatus,
      variables: {
        code: functionalityCode
      }
    });
  }

  setTourStatus(): void {
    if (this.eventData.length === 2 && this.eventData[0].type === 'hide' && (this.eventData[1].type === 'show' || this.eventData[1].type === 'end')) {
      console.log('Removing Tour:', this.eventData[0].anchorId);
      const functionalityCode = this.eventData[0].tourId;
      if (functionalityCode.length && functionalityCode !== 'NA') {
        this.apollo.mutate<any>({
          mutation: updateUserUIFunctionalityStatus,
          variables: {
            functionality_code: functionalityCode,
            status: '2',
          }
        }).subscribe((response) => {
          if (response.data?.updateUserUIFunctionalityStatus?.status === '2') {
            this.eventData = [];
          }
        });
      } else {
        this.eventData = [];
      }
    }
  }

  handleTourEvents(): void {
    this.tourService.events$.subscribe((event: any) => {
      console.log(event);
      if (event.name === 'stepHide') {
        this.eventData.push({
          type: 'hide',
          anchorId: event.value.anchorId,
          tourId: event.value.tourId,
        });
      } else if (event.name === 'stepShow' || event.name === 'end') {
        if (this.eventData.length === 1) {
          this.eventData.push({
            type: event.name === 'stepShow' ? 'show' : 'end',
            anchorId: event.name === 'stepShow' ? event.value.anchorId : '',
            tourId: event.name === 'stepShow' ? event.value.tourId : '',
          })
          this.setTourStatus();
        } else {
          this.eventData = [];
        }
      }
    });
    // this.tourService.end$.subscribe(x => {
    //   console.log(x)
    // });
    // this.tourService.stepShow$.subscribe(step => {
      // if (this.previousStepIndex !== -1) {
        // if (step.stepIndex > this.previousStepIndex) {
        //   console.log('User clicked Next');
        // } else if (step.stepIndex < this.previousStepIndex) {
        //   console.log('User clicked Previous');
        // }
      // }
      // this.previousStepIndex = step.stepIndex;
    // });
  }
}
